import React, { Component} from 'react'
import { connect } from 'react-redux'
import {updateGoogleSignin} from '../../../actions/user'
import {hideModal} from '../../../actions/modals'
import {showNotification} from '../../../actions/notifications'
import GoogleLogin from 'react-google-login'
import errorMessages from '../../../errorMessages.js'
import Button from '../../../components/uiKit/Button'


const responseGoogle = (response) => {}



class ConfirmUpdateGoogleContainer extends Component {

	constructor(){
		super()
		this.handleUpdateGoogleId=this.handleUpdateGoogleId.bind(this)		
	}
	


	handleUpdateGoogleId(oldGoogleUser,){
		this.setState({submitLoading:true})
		const requestData={

			idToken:oldGoogleUser.tokenId,
			idTokenNew:this.props.newGoogleUser.tokenId
		}


		this.props.updateGoogleSignin(this.props.user.id,requestData).then((response) => {
			this.props.hideModal()
		 	this.props.showNotification('your Google account','Updated','default')


		})
			.catch(error => {
				this.props.hideModal()
				let errorMessage='Something went wrong'
				if(errorMessages.accountErrors.updateGoogleSignin[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.updateGoogleSignin[error.response.status]}`
				}
				this.props.showNotification(errorMessage,'Error:','destroy')

			})
	}







	render() {
		const {newGoogleUser}=this.props
		return (
			 <div className={'accountAuthentication accountAuthentication--update '}>     

				

				<div className='accountAuthentication-selectedGoogleAccountCard'>
					New Google Account
					<div className='accountAuthentication-selectedGoogleAccountCard-card'>
						<div className='accountAuthentication-selectedGoogleAccountCard-card-avatar'>
							<img src={newGoogleUser.profileObj.imageUrl} alt=''/>
						</div>
						<div className='accountAuthentication-selectedGoogleAccountCard-card-details'>
							<div className='accountAuthentication-selectedGoogleAccountCard-card-details-name'>
								{newGoogleUser.profileObj.name}
							</div>
							<div className='accountAuthentication-selectedGoogleAccountCard-card-details-email'>
								{newGoogleUser.profileObj.email}
							</div>
						</div>            
					</div>
				</div>
			
				<div className='accountAuthentication-confirmText'>
					Confirm your new Google Sign in by authenticating with<br/><b>your previous Google account</b>.
				</div>
			
				<GoogleLogin
					key='oldAccount'
					clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
					onSuccess={(oldGoogleUser)=>{this.handleUpdateGoogleId(oldGoogleUser)}}
					onFailure={responseGoogle}
					className="accountAuthentication-GoogleBtnContainer"
				>
					<Button
						size='xLarge'
						label='Authenticate with Google to Confirm'
						color='blue'            		
					/>
				</GoogleLogin>
					

				
				

			
			</div>
		)
	}
}



export default connect(
	(state,ownProps) => ({
		user:state.user,
		newGoogleUser:state.modals.googleUser,
		setBanner:state.modals.setBanner
	}),
	{updateGoogleSignin,
		hideModal,

		showNotification}
)(ConfirmUpdateGoogleContainer)


// WEBPACK FOOTER //
// ./src/containers/modals/account/ConfirmUpdateGoogleContainer.js